import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ScheduleType } from '@core/api';
var _obj;
export var DEFAULT_VALUES_TYPE = (_obj = {}, _define_property(_obj, ScheduleType.Daily, {
    hourMinute: {
        hour: 12,
        minute: 0
    }
}), _define_property(_obj, ScheduleType.Hourly, {
    value: 1
}), _define_property(_obj, ScheduleType.Minutely, {
    value: 5
}), _define_property(_obj, ScheduleType.Monthly, {
    hourMinute: {
        hour: 12,
        minute: 0
    },
    value: 1,
    monthDay: 1
}), _define_property(_obj, ScheduleType.Weekly, {
    hourMinute: {
        hour: 12,
        minute: 0
    },
    weekDays: [
        'MONDAY'
    ]
}), _obj);
export var VALID_SCHEDULE_TYPES = Object.values(ScheduleType);

//# sourceMappingURL=FrequencySelectorConstants.js.map